export const portalNotificationEvents = {
	flowInstanceEvent: 'flow.instance.event',
	releasePlanEvent: 'release-plan.event',
	conversationEvent: 'conversation.event',
	reactBuildEvent: 'react-build.event',
} as const;

export const notificationHubMethods = {
	flowDefinition: { subscribe: 'SubscribeToFlowDefinition', unsubscribe: 'UnsubscribeFromFlowDefinition' },
	conversation: { subscribe: 'SubscribeToConversation', unsubscribe: 'UnsubscribeFromConversation' },
	environment: { subscribe: 'SubscribeToEnvironment', unsubscribe: 'UnsubscribeFromEnvironment' },
	reactBuilds: { subscribe: 'SubscribeToReactBuilds', unsubscribe: 'UnsubscribeFromReactBuilds' },
} as const;

export type NotificationSubscriptionScope = keyof typeof notificationHubMethods;
